// extracted by mini-css-extract-plugin
export default {"container":"IntervalSelector_container__mZ1OU","label":"IntervalSelector_label__YpoSk"};